import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Row, Col, Button, Icon } from 'antd';

import {
  URL_HP_PAGE,
  URL_DAS_PAGE,
  URL_HS_MAIN_PAGE,
  URL_HAS_CAMPAIGN_PAGE,
  URL_HAS_HOST_PROTECT_PAGE,
  URL_HAS_ABOUT_US_PAGE,
  URL_HAS_EVENTS_PAGE,
  URL_HAS_BLOG_PAGE,
  URL_HAS_HOST_PAGE,
  URL_HAS_FAQ_PAGE,
  URL_HAS_LEGAL_TERMS_PAGE,
  URL_FB_PAGE,
  URL_INSTA_PAGE,
  URL_YOUTUBE_PAGE,
  URL_LINKEDIN_PAGE
} from 'utils/urls';
import BackgroundImage from './images/bg.svg';

const MainContainer = styled.div`
  background: url(${BackgroundImage}) no-repeat center top;
  background-size: cover;
  height: auto !important;
  padding: 0 ${props => props.theme.padding.contentXPercent}%;
  display: block;
  padding-top: 640px;
  margin-top: -200px;

  @media (min-width: 768px) {
    padding-top: 350px;
    margin-top: 0px;
  }
`;

const SitemapTitle = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px !important;
  color: ${props => props.theme.color.white};
  font-weight: bold;
  letter-spacing: 1px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 28px;
  }
`;

const SitemapLink = styled.a`
  display: block;
  font-size: 13px;
  line-height: 1.8em;
  color: ${props => props.theme.color.white};
  padding: 4px 0 5px 0;
  cursor: pointer;

  :hover {
    color: ${props => props.theme.color.secondary};
  }
`;

const SitemapContent = styled.div`
  display: block;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 2px !important;
  color: ${props => props.theme.color.white};

  @media (min-width: 768px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

const StyledCol = styled(Col)`
  margin-top: 48px;
  @media (min-width: 768px) {
    margin-top: 24px;
  }
`;

const SitemapCol = ({ title, links, content, ...props }) => {
  return (
    <StyledCol {...props}>
      <SitemapTitle>{title}</SitemapTitle>
      {links.map(link => {
        return (
          <SitemapLink key={link.title} href={link.toUrl} target={link.target}>
            {link.title}
          </SitemapLink>
        );
      })}
      <SitemapContent>{content}</SitemapContent>
    </StyledCol>
  );
};

const CopyrightSocial = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: ${props => props.theme.color.primary};
  opacity: 0.7;
`;

const CopyrightSocialRow = styled(Row)`
  justify-content: center;
  background-color: ${props => props.theme.color.white};
  position: absolute;
  width: 100%;
  height: 56px !important;
  margin-left: -${props => props.theme.padding.contentXPercent}%;
  padding: 4px ${props => props.theme.padding.contentXPercent}%;

  @media (min-width: 768px) {
    justify-content: space-between;
  }
`;

SitemapCol.defaultProps = {
  links: []
};

const MediaIcon = styled(Icon)`
  color: ${props => props.theme.color.primary};
`;

const IconLink = styled.a`
  font-size: 12px;
  margin-left: 16px;
  color: ${props => props.theme.color.white};
`;

const EnquireNowButton = styled(Button)`
  width: auto !important;
  padding: 15px 30px 13px !important;
  border: 3px solid ${props => props.theme.color.white} !important;
  border-radius: 3px !important;
  background-color: transparent;
  height: 100% !important;
  color: ${props => props.theme.color.white} !important;

  @media (min-width: 768px) {
    width: auto;
  }

  &:hover {
    opacity: 0.7;
    background: transparent;
  }
`;

const Footer = () => {
  return (
    <MainContainer>
      <Row type="flex" justify="space-around" gutter={24} align="top" style={{ paddingBottom: 36, marginTop: '24px' }}>
        <SitemapCol
          title="HOSTASTAY"
          links={[
            {
              title: 'CAMPAIGN',
              toUrl: URL_HAS_CAMPAIGN_PAGE
            },
            {
              title: 'OWNER',
              toUrl: URL_HS_MAIN_PAGE
            },
            {
              title: 'HOST',
              toUrl: URL_HAS_HOST_PAGE
            },
            {
              title: 'ABOUT US',
              toUrl: URL_HAS_ABOUT_US_PAGE
            },
            {
              title: 'EVENTS',
              toUrl: URL_HAS_EVENTS_PAGE
            },
            {
              title: 'BLOG',
              toUrl: URL_HAS_BLOG_PAGE
            }
          ]}
          span={24}
          md={6}
        />
        <SitemapCol
          title="OUR SERVICES"
          links={[
            {
              title: 'Short Stay Management System',
              toUrl: URL_HP_PAGE,
              target: '_blank'
            },
            {
              title: 'Interior Design & Renovation',
              toUrl: URL_DAS_PAGE,
              target: '_blank'
            },
            {
              title: 'Short Stay Insurance',
              toUrl: URL_HAS_HOST_PROTECT_PAGE
            }
          ]}
          span={24}
          md={6}
        />
        <SitemapCol
          title=""
          links={[
            {
              title: 'Help Center',
              toUrl: URL_HAS_FAQ_PAGE
            },
            {
              title: 'Legal Terms',
              toUrl: URL_HAS_LEGAL_TERMS_PAGE
            }
          ]}
          span={24}
          md={6}
        />
        <SitemapCol
          content={
            <span>
              <p style={{ fontSize: '16px', lineSpacing: '1px' }}>
                <b>GET IN TOUCH WITH US</b>
              </p>
              <p style={{ fontSize: '15px' }}>Lot 17-07, Faber Towers, 207, Jalan Desa Bahagia, Taman Desa, 58100 Kuala Lumpur, Malaysia</p>
              <p style={{ fontSize: '15px' }}><a href="mailto:enquiry@hostastay.com">enquiry@hostastay.com</a></p>
              <EnquireNowButton>
                <Link to="/enquiry">Enquire Now</Link>
              </EnquireNowButton>
            </span>
          }
          span={24}
          md={6}
        />
      </Row>
      <CopyrightSocialRow type="flex" align="middle" justify="space-between">
        <CopyrightSocial>© Copyright - {new Date().getFullYear()} Host A Stay</CopyrightSocial>
        <CopyrightSocial>
          <IconLink href={URL_FB_PAGE} target="_blank">
            <MediaIcon type="facebook" />
          </IconLink>
          <IconLink href={URL_INSTA_PAGE} target="_blank">
            <MediaIcon type="instagram" />
          </IconLink>
          <IconLink href={URL_YOUTUBE_PAGE} target="_blank">
            <MediaIcon type="youtube" />
          </IconLink>
          <IconLink href={URL_LINKEDIN_PAGE} target="_blank">
            <MediaIcon type="linkedin" />
          </IconLink>
        </CopyrightSocial>
      </CopyrightSocialRow>
    </MainContainer>
  );
};

export default Footer;
